<template>
  <div class="rules">
    <!--    <div class="dsxz">-->
    <!--      <div>大赛细则</div>-->
    <!--    </div>-->
    <div class="csxz-con">
      <div>
        <div class="title csxz"></div>
        <div>
          <p>
            <span class="numbers"><img src="../assets/one.png"/></span
            >主办方会根据报名情况对拟参赛的机构及产品进行审核，并反馈是否报名成功。
          </p>
          <p>
            <span class="numbers"><img src="../assets/two.png"/></span
            >管理人报名参赛即视为其已承诺将如实填报管理人信息及净值等数据。
          </p>
          <p>
            <span class="numbers"><img src="../assets/three.png"/></span
            >参赛机构应于每周三（节假日顺延）17：00前到大赛指定平台录入上周最后一个交易日的累计净值等数据。主办方工作人员将会对净值进行审核，因参赛私募报送错误或报送不及时产生的排名误差，参赛私募自行负责。
          </p>
          <p>
            <span class="numbers"><img src="../assets/four.png"/></span
            >大赛期间收益率为负的产品，不参与年度获奖评选。
          </p>
          <p>
            <span class="numbers"><img src="../assets/five.png"/></span
            >参赛私募自负盈亏，参赛私募需保证报送的数据及时准确全面，参赛私募应签署授权书，授权主办方及联合主办方获取比赛相关数据，并可在官网、微信、微博、APP等其他系统中进行合规宣传或披露。
          </p>
          <p>
            <span class="numbers"><img src="../assets/six.png"/></span
            >2022年1月1日前报名的产品，以2021年12月31日的净值等数据为初始成绩；2022年1月1日起报名的产品，以报名后录入的最早净值等数据为初始成绩。
          </p>
          <p>
            <span class="numbers"><img src="../assets/seven.png"/></span
            >每季度后，排行前三名的参赛机构，应主动提交经托管人确认的季度净值数据到大赛指定邮箱（lhmj@kiiik.com），以便大赛组委进行核对。
          </p>
          <p>
            <span class="numbers"><img src="../assets/eight.png"/></span
            >参赛产品要求真实有效，且持续净值更新。若经大赛组委核实净值有误，或净值一个月以上未更新，主办方有权取消参赛资格。
          </p>
          <p>
            <span class="numbers"><img src="../assets/nine.png"/></span
            >东航金控种子基金，将对部分参赛私募机构产品进行跟投或合作发行产品。投资前，私募机构需与资方进行商务洽谈。
          </p>
          <p>
            <span class="numbers"><img src="../assets/ten.png"/></span
            >本次比赛为私募机构实盘交易比赛，参赛机构自行交易，所有交易须遵守相关法律法规。主办机构发现或有人举报，经核实认定参赛机构确有舞弊行为或操纵市场等嫌疑的，立即取消参赛机构的参赛资格；由此产生的一切后果由参赛机构承担。
          </p>
          <p>
            <span class="numbers"><img src="../assets/eleven.png"/></span
            >机构参与比赛，则视为同意东航期货、云纪网络获得及使用机构按大赛要求提供的所有数据。当主办方提出查验数据真实性时，参赛机构应当配合提供比赛期间的经托管人盖章的相关数据。如果查验数据发现虚假数据或未配合提供托管人盖章数据，则不参与榜单排名。
          </p>
          <p>
            <span class="numbers"><img src="../assets/twelve.png"/></span
            >本次比赛排名收益率仅供参考，不构成任何投资建议。
          </p>
          <p>
            <span class="numbers"><img src="../assets/thirteen.png"/></span
            >比赛结束后，主办方将以电话或电子邮件方式通知获奖机构的报名联系人，若无法与获奖机构的联系人取得联系，则视为获奖机构自动放弃获奖权益。
          </p>
        </div>
      </div>
    </div>
    <div class="csfz-con">
      <div>
        <div class="title csfz"></div>
        <div class="five-level level">
          <div>
            <div class="item firlineitem">
              <img src="../assets/gp.png" />
              <div class="fztitle">股票策略</div>
              <div class="fzsub">主要投资于股票市场，且总头寸占比超60%</div>
            </div>
            <div class="item firlineitem">
              <img src="../assets/dc.png" />
              <div class="fztitle">对冲策略</div>
              <div class="fzsub">
                <div>主同时持有资产相关、规模相当的多空头寸策略，</div>
                <div>且总头寸占比超60%</div>
              </div>
            </div>
          </div>
          <div>
            <div class="item seclineitem">
              <img src="../assets/CTA.png" />
              <div class="fztitle">CTA及衍生品策略</div>
              <div class="fzsub">
                <div>主要投资于商品及金融衍生品，</div>
                <div>且投资比例超60%</div>
              </div>
            </div>
            <div class="item">
              <img src="../assets/hh.png" />
              <div class="fztitle">混合策略</div>
              <div class="fzsub">
                <div>采用多种投资策略，</div>
                <div>且每种策略的投资比例不超过60%</div>
              </div>
            </div>
            <div class="item seclineitem">
              <img src="../assets/qt.png" />
              <div class="fztitle">其他策略</div>
              <div class="fzsub">包括固收、日内等其他各种策略</div>
            </div>
          </div>
        </div>
        <!--      <div class="remark fourremark">备注：报名后，当赛季不得变更产品类型</div>-->
      </div>
    </div>
    <div class="pfff-con">
      <div>
        <div class="title pfff"></div>
        <div>
          <p>
            大赛将按照股票策略、对冲策略、CTA及衍生品策略、混合策略及其他策略共5项策略进行评比。周三晚21:00左右（节假日顺延）更新综合排名。
          </p>
          <p>
            主办方根据产品参赛期间的净收益率，以及年化夏普比率、最大回撤等风险调整指标综合评价产品的表现，同时主办方专家评审结合产品规模、当赛季累计收益额、参赛时长、管理人在参赛期间的整体表现等情况进行综合打分。
          </p>
        </div>
        <div class="table">
          <table>
            <tr align="center" style="height: 65px; color: #27a7ea">
              <th style="width: 170px;"></th>
              <th style="width: 300px;">维度</th>
              <th style="width: 230px;">权重</th>
            </tr>
            <tr align="center" style="height: 55px;">
              <th rowspan="4" style="height: 220px; color: #27a7ea">
                综合评分
              </th>
              <td style="height: 52px;">参赛期间净收益率</td>
              <td>40%</td>
            </tr>
            <tr align="center">
              <td style="height: 52px;">年化夏普比率</td>
              <td>20%</td>
            </tr>
            <tr align="center">
              <td style="height: 52px;">参赛期间最大回撤</td>
              <td>20%</td>
            </tr>
            <tr align="center">
              <td style="height: 52px;">专家评审</td>
              <td>20%</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="bmfs-con">
      <div>
        <div class="title bmfs"></div>
        <div class="two-level level">
          <div>
            <img src="../assets/PCd.png" />
            <!-- <div class="fztitle">网上Web端活动页面报名，随时可报名</div> -->
            <!-- <div class="fztitle" @click="gosignup('bm')">立即报名&gt;</div> -->
            <!-- <el-button  class="fztitle" @click="gosignup('bm')" type="text">立即报名 &gt;</el-button> -->
            <el-link type="primary" class="fztitle" @click="gosignup('signup')"
              >立即报名 &gt;</el-link
            >
          </div>
          <div>
            <!-- <img src="../assets/ydd.png" /> -->
            <img src="../assets/pof.png" />
            <!-- <div class="fztitle">手机移动端H5页面报名，随时可报名</div> -->
            <div class="fztitle">使用手机扫码报名</div>
          </div>
          <!--          <div><img src="../assets/hzjgdr.png"/>-->
          <!--            <div class="fztitle">合作机构导入</div>-->
          <!--          </div>-->
        </div>
        <!--        <div class="remark">报名时间：2019年10月1日起，均可报名 （产品参与展示不足9个月不参与当年的奖项评定）</div>-->
      </div>
    </div>
    <div class="jztbfs-con">
      <div>
        <div class="title jztbfs"></div>
        <div class="two-level level">
          <div>
            <img src="../assets/dlwztb.png" />
            <!-- <div class="fztitle">登录网站填报</div> -->
            <el-link type="primary" class="fztitle" @click="gosignup('personal')"
              >登录网站填报 &gt;</el-link
            ><br>
            <el-link
              type="primary"
              class="fztitle"
              target="_blank"
              href="./static/lhmj-gw-jztb.pdf"
              >净值录入指引</el-link
            >
          </div>
          <div>
            <img src="../assets/CBS.png" />
            <div class="fztitle">CBS填报</div>
            <!-- <a class="link" target="_blank" href="./static/lhmj-cbs.pdf">净值录入指引</a> -->
            <el-link
              type="primary"
              class="fztitle"
              target="_blank"
              href="./static/lhmj-cbs.pdf"
              >净值录入指引</el-link
            >
          </div>
          <!--          <div><img src="../assets/tgryjfs.png"/>-->
          <!--            <div class="fztitle">托管人邮件发送</div>-->
          <!--          </div>-->
        </div>
        <!--        <div class="tbremark">-->
        <!--          <div>-->
        <!--            <p>比赛期间，参赛管理人于每周二17：00前，登录大赛官网填报参赛产品上周最后一个交易日的净值和当年累计收益。</p>-->
        <!--            <p class="notice">提示：参赛期内每季度结束后7个工作日内，各参赛机构向指定邮箱发送托管人核对结果敲章版，以便大赛组委进行核对。</p>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <p>参赛管理人通知托管方于每周二17：00前，发送参赛产品上周最后一个交易日的净值和当年累计收益，至大赛指定邮箱：<span>lhmj@kiiik.com</span>。</p>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="loginDiv">
      <login
        v-if="showlogin"
        @closelogin="closelogin"
        @goaffirm="goaffirm"
        @goforgetpwd="goforgetpwd"
        @gosurvey="gosurvey"
      ></login>
      <affirm
        v-if="showaffirm"
        @closeaffirm="closeaffirm"
        @goreg="goreg"
      ></affirm>
      <reg v-if="showreg" @closereg="closereg" @gologin="gologin"></reg>
      <forgetpwd
        v-if="showforgetpwd"
        @closeforgetpwd="closeforgetpwd"
        @pwdgologin="pwdgologin"
      ></forgetpwd>
      <survey v-if="showsurvey" @closesurvey="closesurvey"></survey>
      <notice
        v-if="$store.state.noticeMessage != ''"
        :noticeMessage="$store.state.noticeMessage"
        @sureClose="sureClose"
      ></notice>
    </div>
  </div>
</template>
<script>
import { http } from "../fetch/api";
import login from "./login";
import affirm from "./affirm";
import reg from "./reg";
import survey from "./survey";
import forgetpwd from "./forgetpwd";
import format from "../fetch/format";
export default {
  components: {
    login,
    affirm,
    reg,
    survey,
    forgetpwd
  },
  data() {
    return {
      showlogin: false,
      showaffirm: false,
      showreg: false,
      showsurvey: false,
      showforgetpwd: false
    };
  },
  methods: {
    async gosignup(active) {
      console.log(active)
      // 是否登录
      if (this.$store.state.loginState) {
        var temp = format.formatKeys(this.$route.query);
        var params = temp.substring(0, temp.length - 1);
        if(active == "personal") {
          this.$router.push("/personal");
          return
        }
        if (window.localStorage.institutId != "null") {
          //是否已经填写私募管理人信息
          var data = await http.basicInfo();
          this.basicInfo = data.data;
          if (
            this.basicInfo &&
            this.basicInfo.institut &&
            ((this.basicInfo.institut.productList &&
              this.basicInfo.institut.productList.length < 8) ||
              !this.basicInfo.institut.productList)
          ) {
            if (this.basicInfo.institut.productList) {
              window.localStorage.productList = this.basicInfo.institut.productList.length;
            } else {
              window.localStorage.productList = 0;
            }
            this.$store.state.active = active;
            console.log(active);
            // this.$router.push("/signup?" + params);
            this.$router.push("/" + active + "?" + params);
          } else {
            window.localStorage.productList = 8;
            this.$store.state.noticeMessage = "您已有8个产品参赛，暂不能报名";
            return;
          }
        } else {
          this.$store.state.active = active;
          this.$router.push("/manager?" + params);
        }
      } else  {
        this.showlogin = true;
        this.type = active;
        console.log(this.type,'00000000')
      }
    },
    closelogin(only) {
      console.log(this.type,"rules")
      this.showlogin = false;
      if (only == "only") {
      } else {
        if (!this.type) {
          // this.$router.push({"path":"/personal"})
        } else {
          var temp = format.formatKeys(this.$route.query);
          var params = temp.substring(0, temp.length - 1);
          // this.$router.push("/personal?"+params)
          if (this.type == "rank") {
            //跳转到排行榜页面
            this.$router.push("/rank?" + params);
            this.$store.state.active = "ph";
          } else if (this.type == "prevRank") {
            //跳转到上赛季排行页面
            this.$router.push("/prevRank?" + params);
            this.$store.state.active = "sph";
          } else if (this.type == "personal") {
            //跳转到上赛季排行页面
            this.$router.push("/personal?" + params);
            this.$store.state.active = "per";
          } else if (this.type == "signup") {
            //从报名参赛点进来
            this.$store.state.active = "";
            if (window.localStorage.institutId != "null") {
              //已填写私募管理人信息
              this.$router.push("/signup?" + params);
            } else {
              //未填写私募管理人信息
              this.$router.push("/manager?" + params);
            }
          }
        }
      }
    },
    goaffirm() {
      this.showlogin = false;
      this.showaffirm = true;
    },
    gosurvey() {
      this.showlogin = false;
      //隐藏掉调查问卷
      // this.showsurvey = true
    },
    closereg() {
        this.showreg = false
      },
      closeforgetpwd() {
        this.showforgetpwd = false
      },
      closeaffirm() {
        this.showaffirm = false
      },
      closesurvey() {
        this.showsurvey = false
      },
      gologin() {
        this.showreg = false
        this.showlogin = true
        this.type = ""
      },
      pwdgologin() {
        this.showforgetpwd=false
        this.showlogin=true
        this.type=""
      },
      goreg() {
        this.showaffirm = false
        this.showreg = true
      },
      goforgetpwd() {
        this.showlogin = false
        this.showforgetpwd = true
      },
      sureClose() {
        this.$store.state.noticeMessage = ""
      },
      async getLoginState() {
        var data = await http.loginState()
        if (data.code == '0') {
          this.$store.state.loginState = true
        } else if (data.code == '1') {
          this.$store.state.loginState = false
        }
      },
  }
};
</script>
<style scoped>
.dsxz {
  height: 60px;
  line-height: 60px;
  background: #f4f7f9;
}

.dsxz div {
  width: 1200px;
  margin: 0 auto;
  font-size: 16px;
}

.csxz-con > div,
.csfz-con > div,
.pfff-con > div,
.bmfs-con > div,
.jztbfs-con > div {
  padding: 50px 0;
  width: 1200px;
  margin: 0 auto;
}

.title {
  height: 67px;
  line-height: 67px;
  text-align: center;
  font-size: 30px;
  letter-spacing: 5px;
  margin: 0 auto 35px auto;
  background-repeat: no-repeat;
  background-size: 750px;
  background-position: center;
}

.title span {
  padding-left: 50px;
  display: inline-block;
  background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
  background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
  background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
  background-image: linear-gradient(73deg, #0c3b95, #cf5860);
  -webkit-background-clip: text;
  -ms-background-clip: text;
  -o-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -o-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  text-fill-color: transparent;
  font-weight: bold;
}

p {
  position: relative;
  font-size: 16px;
  /*text-indent: 32px;*/
  padding: 0 70px 0 116px;
  line-height: 32px;
  margin-top: 20px;
  letter-spacing: 1px;
}

.numbers {
  position: absolute;
  left: 70px;
}

.numbers img {
  margin-right: 10px;
  width: 36px;
  vertical-align: middle;
  margin-top: -6px;
}

.csxz {
  background-image: url("../assets/csxz.png");
}

.csfz {
  background-image: url("../assets/csfz.png");
}

.pfff {
  background-image: url("../assets/pfff.png");
}

.bmfs {
  background-image: url("../assets/bmfs.png");
}

.jztbfs {
  background-image: url("../assets/jztbfs.png");
}

.level {
  margin: 0 auto;
}

.five-level {
  width: 1010px;
  text-align: center;
}

.two-level {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.two-level > div {
  display: inline-block;
  width: 500px;
  text-align: center;
}
.jztbfs-con .two-level {
  width: 1200px;
}

.level .item {
  display: inline-block;
  width: 333px;
  text-align: center;
  vertical-align: top;
  padding: 0 45px;
  box-sizing: border-box;
}
.level .firlineitem {
  margin-bottom: 30px;
  width: 500px;
}
.level img {
  display: block;
  width: 148px;
  margin: 0 auto;
}
.fztitle {
  margin-top: 10px;
  font-size: 18px;
}
.fzsub {
  color: #6e6e6e;
  height: 60px;
  line-height: 30px;
  font-size: 16px;
}
.remark {
  margin: 20px auto 0 auto;
  font-size: 16px;
  padding-left: 51px;
  box-sizing: border-box;
}

.csfz-con .remark {
  width: 1000px;
}

.bmfs-con .remark {
  width: 750px;
}

.fourremark {
  color: #6e6e6e;
  margin-top: 30px;
}

.pfff-con p {
  font-size: 16px;
  text-indent: 32px;
}

.table {
  box-sizing: content-box;
  margin: 30px auto 0 auto;
  width: 707px;
  height: 300px;
  font-size: 16px;
  background-image: url("../assets/xz-tablebg.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.tbremark > div {
  display: inline-block;
  width: 600px;
  box-sizing: border-box;
  vertical-align: top;
  font-size: 16px;
  padding: 50px;
}

.tbremark p.notice {
  color: #f53f3f;
  margin-top: 0;
}

.tbremark span {
  color: #27a7ea;
  text-decoration: underline;
}

.tbremark p {
  padding: 0 30px;
  line-height: 24px;
}
.link {
  display: inline-block;
  color: #27a7ea;
  text-decoration: underline;
}
.loginDiv {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/rules.vue